import { Button, Drawer, Hairline, Label, Loading, Message, Select } from "@components";
import React from "react";
import Toggle2 from "shared/components/Toggle2";
import styles from "../../../../styles/integrations.module.scss";
import { EnvironmentStorage } from "shared/tools/EnvironmentStorage";
import { EnvironmentsAPI } from "providers/EnvironmentsAPI";
import ManualConfirmLoginDrawer from "./ManualConfirmLoginDrawer";
import { If } from "shared/components/control-statements";
import { UserStorage } from "shared/tools/UserStorage";

const ValidationField = {
  PHONE: "PHONE",
  EMAIL: "EMAIL",
};

export default class ConfirmLoginDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      manualConfirmOpen: false,
      validations: [],
      pageLoading: true,
      phone: {
        otp: null,
      },
      email: {
        otp: null,
      },
    };
  }

  async componentDidMount() {
    const environment_id = await EnvironmentStorage.getEnvironmentHoldingId();

    const customer_validations = await EnvironmentsAPI.getConfigurationsByAlias(
      environment_id,
      "customer_validations",
      []
    );
    const validations = await EnvironmentsAPI.getConfigurationsByAlias(
      environment_id,
      "validations",
      {}
    );

    this.setState({
      validations: customer_validations,
      ...validations,
      pageLoading: false,
    });
  }

  async onToggleValidation(type) {
    const { validations } = this.state;
    if (validations.includes(type)) {
      this.setState({
        validations: validations.filter((validation) => validation !== type),
      });
    } else {
      this.setState({
        validations: [...validations, type],
      });
    }
  }

  async save() {
    const { validations, phone, email } = this.state;

    this.setState({ loading: true });

    const holdingId = await EnvironmentStorage.getEnvironmentHoldingId();

    const validations_payload = {
      validations: {
        phone: {
          enabled: validations.includes(ValidationField.PHONE),
          otp: phone.otp,
        },
        email: {
          enabled: validations.includes(ValidationField.EMAIL),
          otp: email.otp,
        },
      },
    };
    await EnvironmentsAPI.putConfigurationsByAlias(
      holdingId,
      "validations",
      validations_payload
    );

    const payload = { customer_validations: validations };
    const validationResponse = await EnvironmentsAPI.putConfigurationsByAlias(
      holdingId,
      "customer_validations",
      payload
    );
    if (validationResponse.getErrors([]).length > 0) {
      alert({
        text: validationResponse.getErrors()[0],
        buttonText: "Ok",
      });
      this.setState({ loading: false });
      return false;
    }

    alert({
      text: "Configuração alterada com sucesso!",
      buttonText: "Ok",
    });

    this.setState({ loading: false });
    return true;
  }

  render() {
    const { visible, onClose } = this.props;
    const { loading, validations, manualConfirmOpen, phone, pageLoading } = this.state;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title="Validações de cadastro"
      >
        {pageLoading ? (
          <div className="d-flex align-center justify-center h-100 w-100">
            <Loading />
          </div>
        ) : (
          <>
            <Message
              type="warning"
              className="mb-20"
              text="A ativação da confirmação do telefone resultará em cobranças pelo envio de SMS e E-mail. As validações acontecerão somente uma vez por conta, no cadastro, ou no login, ou na edição da conta."
            />
            <div className="d-flex flex-column gap-10">
              <div className={styles.box}>
                <Toggle2
                  id="confirm-phone"
                  title="Validação do telefone via SMS"
                  checked={validations.includes(ValidationField.PHONE)}
                  onChange={() =>
                    this.onToggleValidation(ValidationField.PHONE)
                  }
                />
              </div>
              <div className={styles.box}>
                <Toggle2
                  id="confirm-email"
                  title="Validação do e-mail"
                  checked={validations.includes(ValidationField.EMAIL)}
                  onChange={() =>
                    this.onToggleValidation(ValidationField.EMAIL)
                  }
                />
              </div>
            </div>
            <If cond={UserStorage.isGodMode}>
              <Hairline className="mt-15 mb-15" />
              <Label>Fornecedor de OTP telefone</Label>
              <Select
                design="two"
                onChange={(e) =>
                  this.setState({ phone: { ...phone, otp: e.target.value } })
                }
                className="mb-20"
                value={phone?.otp}
                options={[
                  {
                    label: "PontalTech",
                    value: "pontal-tech",
                    selected: phone?.otp === "pontal-tech",
                  },
                  {
                    label: "Twilio",
                    value: "twilio",
                    selected: phone?.otp === "twilio",
                  },
                ]}
              />
            </If>

            <div className={styles.footer}>
              <Button
                className="w-100"
                design="primary"
                disabled={loading}
                loading={loading}
                onClick={() => this.save()}
              >
                Salvar alterações
              </Button>
              <div className="d-flex justify-center mt-20">
                <Button
                  design="underline"
                  onClick={() => this.setState({ manualConfirmOpen: true })}
                >
                  Liberar confirmação de um cliente
                </Button>
              </div>
            </div>
          </>
        )}

        <ManualConfirmLoginDrawer
          visible={manualConfirmOpen}
          onClose={() => this.setState({ manualConfirmOpen: false })}
        />
      </Drawer>
    );
  }
}
